import { Context, Logger } from '@vue-storefront/core';
import { GraphQLError } from 'graphql';
import { IAutomaticDiscount } from '@composables/src/types';
import { IUseAutomaticDiscountsRefs } from '../types';

const getAutomaticDiscounts =
  (context: Context, refs: IUseAutomaticDiscountsRefs, id: string) => async () => {
    Logger.debug(`useAutomaticDiscounts/${id}/getAutomaticDiscounts`);

    try {
      refs.result.value = null;
      refs.error.value = null;
      refs.loading.value = true;

      const response: IAutomaticDiscount[] | GraphQLError =
        await context.$shopifyAdmin.api.getAutomaticDiscounts();

      if (!response || (response as GraphQLError).message || !Array.isArray(response)) {
        refs.error.value = new Error('Unable to get automatic discounts.');
      } else {
        refs.result.value = response as IAutomaticDiscount[];
      }
    } catch (error) {
      refs.error.value = error as Error;
      Logger.error(`useAutomaticDiscounts/${id}/getAutomaticDiscounts/error`, error);
    } finally {
      refs.loading.value = false;
    }
  };

export default getAutomaticDiscounts;
